import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmDeleteDialogData {
    title: string;
    message: string;
    itemName?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

@Component({
    selector: 'app-confirm-delete-dialog',
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    template: `
    <div class="confirm-delete-dialog">
      <!-- Header -->
      <div class="flex items-center p-6 border-b border-gray-200">
        <mat-icon class="text-red-600 mr-3 text-2xl">warning</mat-icon>
        <h2 class="text-xl font-semibold text-gray-900">{{ data.title }}</h2>
      </div>

      <!-- Content -->
      <div mat-dialog-content class="p-6">
        <p class="text-gray-700 mb-4">{{ data.message }}</p>
        
        @if (data.itemName) {
        <div class="bg-red-50 border border-red-200 rounded-lg p-4">
          <div class="flex items-center">
            <mat-icon class="text-red-600 mr-2">person</mat-icon>
            <span class="font-medium text-red-900">{{ data.itemName }}</span>
          </div>
        </div>
        }

        <div class="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <div class="flex items-start">
            <mat-icon class="text-yellow-600 mr-2 mt-0.5 text-sm">info</mat-icon>
            <div class="text-sm text-yellow-800">
              <p class="font-medium">Warning:</p>
              <p>This action cannot be undone. The operator will be permanently removed from the system.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div mat-dialog-actions class="flex justify-end gap-3 p-6 bg-gray-50 border-t border-gray-200">
        <button 
          mat-button 
          type="button" 
          (click)="onCancel()" 
          class="px-4 py-2">
          {{ data.cancelButtonText || 'Cancel' }}
        </button>
        <button 
          mat-raised-button 
          color="warn" 
          type="button" 
          (click)="onConfirm()" 
          class="px-6 py-2">
          <mat-icon class="mr-1 text-sm">delete_forever</mat-icon>
          {{ data.confirmButtonText || 'Delete' }}
        </button>
      </div>
    </div>
  `,
    styles: [`
    .confirm-delete-dialog {
      min-width: 400px;
      max-width: 500px;
    }
    
    @media (max-width: 640px) {
      .confirm-delete-dialog {
        min-width: 300px;
        max-width: 90vw;
      }
    }
    .mat-icon{
        width: 48px !important;
    }
  `]
})
export class ConfirmDeleteDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteDialogData
    ) { }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }
}